import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { deadlineInfo } from '@/mocks/applicationData';

export default function DeadlineInfo() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('application.deadline.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {lang === 'en' ? t('application.deadline.title') : deadlineInfo.title}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {deadlineInfo.titleEn}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {lang === 'en' ? t('application.deadline.lead') : deadlineInfo.lead}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {deadlineInfo.items.map((item, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 p-5 flex items-start gap-4 group"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/10 flex-shrink-0">
                <i className={`${item.icon} text-accent-600 text-sm`}></i>
              </div>
              <div>
                <p className="text-[13px] text-foreground-400 tracking-[0.08em] font-label mb-1">
                  {lang === 'en' ? t(`application.deadline.item.${idx}.label`) : item.label}
                </p>
                <p className="text-[16px] text-foreground-800 tracking-[0.04em] leading-relaxed">
                  {lang === 'en' ? t(`application.deadline.item.${idx}.value`) : item.value}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-6">
          {t('application.deadline.contactNote')}
          <Link to="/schedule" className="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors mx-1">
            {t('application.deadline.contactLink')}
          </Link>
          {t('application.deadline.contactSuffix')}
        </p>
      </div>
    </section>
  );
}
